import { style } from '@do/walrus';
import styled from 'styled-components';

const FooterWrap = styled.div`
  width: 100%;
  text-align: center;
  font-size: ${style.vars.fontSize.small};
  margin-top: ${style.vars.whitespace.regular};
  padding-left: ${style.vars.whitespace.medium};
  padding-right: ${style.vars.whitespace.medium};
`;

export default FooterWrap;
